import React from "react";
import { Container, Box, Typography } from "@mui/material";
import { StandardPageHead } from "../components/Heads/StandardPageHead.tsx";

const arrayOfText: string[] = [
  "CinemaGuide was built to help people in Ireland view what's on in Cinemas near them quickly and easily.",
  "CinemaGuide has listings for over 70 cinemas across Ireland, covering all major chains and many independent cinemas.",
  "If you have any suggestions for improvements, cinemas you'd like to see added to the site, or ideas for collaboration please get in touch via LinkedIn: https://www.linkedin.com/in/tom-benbow/ or email: tombenbow@gmail.com.",
];

export const AboutPage: React.FC = () => {
  return (
    <>
      <StandardPageHead
        title="CinemaGuide About Page"
        description="Learn more about CinemaGuide, the #1 platform for movie showtimes and cinema listings in Ireland."
        pageUrl="https://cinemaguideireland.com/about"
      />
      <Container sx={{ width: { xs: "100%", md: "60%" } }}>
        <Box
          marginTop={{ xs: 3, md: 5 }}
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="left"
        >
          {arrayOfText.map((text: string) => {
            return (
              <Typography
                variant="body1"
                textAlign="left"
                sx={{
                  marginBottom: 2,
                  fontSize: { xs: "small", md: "medium" },
                }}
              >
                {text}
              </Typography>
            );
          })}
        </Box>
      </Container>
    </>
  );
};
